import React from 'react'
import CashZoneButton from '../CashZoneButton'

const Cash2cashZoneComponent = () => {
    return (
        <>
            <div className="">
                <table width="100%" cellspacing="0" cellpadding="0" className='border-b-none border border-slate bg-charcoal text-xs text-white font-Serif p-2.5 lg:p-0'>
                    <tbody>
                        <tr>
                            <th className='text-white p-2.5 lg:py-0 lg:px-2.5 bg-graphite border-r-slate border-b-slate border-b border-r hidden lg:table-cell'>보유금액</th>
                            <td align="left" className='p-2.5 border-b-slate border-b lg:h-[56px]'>
                                <span className='text-[#ff9241] lg:text-[#f22200] text-base font-bold ' ><span className='text-white text-xs lg:hidden' >보유금액</span> 0 원</span>
                                {/* <span className='text-[#f22200] text-base font-bold' > 0 원</span> */}
                            </td>
                        </tr>
                        <tr>
                            <th className='text-white p-2.5 lg:py-0 lg:px-2.5 bg-graphite border-r-slate border-b-slate border-b border-r hidden lg:table-cell'>충전금액</th>
                            <td align="left" className='p-2.5 border-b-slate border-b h-[56px]'>
                                <input name="money" type="text" className="max-w-[187px] w-full font-NotoSansKR border bg-obsidian text-white text-xs leading-[36px] lg:leading-[39px] h-[36px] lg:h-[39px] transition-[0.2s] align-middle px-[5px] py-0.5 pe-[5px] lg:rounded-[5px]  lg:focus:border-indigoBlue focus:border-[#ffcc00] border-slate me-1 outline-none" />

                                &nbsp;&nbsp;
                                <div className='hidden lg:inline'>
                                    <CashZoneButton label="2만원" link_src="#" active_color="bg-amberGold" active={false} type="link"/>
                                    <CashZoneButton label="5만원" link_src="#" active_color="bg-amberGold" active={false} type="link"/>
                                    <CashZoneButton label="10만원" link_src="#" active_color="bg-amberGold" active={false} type="link"/>
                                    <CashZoneButton label="50만원" link_src="#" active_color="bg-amberGold" active={false} type="link"/>
                                    <CashZoneButton label="100만원" link_src="#" active_color="bg-amberGold" active={false} type="link"/>
                                    <CashZoneButton label="500만원" link_src="#" active_color="bg-amberGold" active={false} type="link"/>
                                    <CashZoneButton label="정정" link_src="#" active_color="bg-amberGold" active={true} type="link"/>
                                </div>
                            </td>
                        </tr>
                        <tr className='lg:hidden'>
                            <td align="left" className='p-2.5 border-b-slate border-b font-sans-serif h-[56px]' colSpan="2">
                                <CashZoneButton label="2만원" link_src="#" active_color="bg-amberGold" active={false} type="link"/>
                                <CashZoneButton label="5만원" link_src="#" active_color="bg-amberGold" active={false} type="link"/>
                                <CashZoneButton label="10만원" link_src="#" active_color="bg-amberGold" active={false} type="link"/>
                                <CashZoneButton label="50만원" link_src="#" active_color="bg-amberGold" active={false} type="link"/>
                                <CashZoneButton label="100만원" link_src="#" active_color="bg-amberGold" active={false} type="link"/>
                                <CashZoneButton label="500만원" link_src="#" active_color="bg-amberGold" active={false} type="link"/>
                                <CashZoneButton label="정정" link_src="#" active_color="bg-amberGold" active={true} type="link"/>
                            </td>
                        </tr>
                        <tr className=''>
                            <td align="left" className='p-2.5 border-b-slate border-b font-sans-serif lg:font-Serif lg:h-[56px]' colSpan="2">
                                <span className='text-[#006FE5] lg:text-[#ff3434] text-[11px] lg:text-xs font-normal'>
                                    최소
                                    <span className="text-right pe-[5px] font-bold" > 10,000원</span>
                                    이상,
                                    <span className="text-right pe-[5px] font-bold" > 10,000원</span>
                                    단위로 환전 가능합니다.
                                </span>
                            </td>
                        </tr>
                        <tr className=''>
                            <td align="left" className='p-2.5 border-b-slate border-b font-Serif lg:h-[56px]' colSpan="2">
                                <ul className='text-xs text-white'>
                                    <li className='my-1 '><strong>거래은행</strong> : 농협중앙</li>
                                    <li className='my-1 '><strong>계좌번호</strong> : 351035350****</li>
                                    <li className='my-1 '><strong>예금주</strong> : 이대형</li>
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default Cash2cashZoneComponent